<template>
  <div v-if="loading" class="overlay">
    <div class="spinner" :style="spinnerStyle"></div>
    <slot>{{ $t("product_detail.loading") }}</slot>
  </div>
  <template v-else>

    <div v-if="isDelegue && !selectedVeterinarian" class="delegate-warning cart-page container text-align-center  ">
      <div class="container">
        <div class="warning-message">
          <i class="ti ti-alert-circle"></i>
          <span>Veuillez sélectionner un vétérinaire d'abord</span>
          <router-link to="/dashboard" class="warning-link"> Retour au tableau de bord </router-link>
        </div>
      </div>
    </div>
  <template v-else>

     <div class="bg-light product-page" >
      <div class="container section-header-breadcrumb pt-3 pb-4">
        <div class="row">
          <div class="content text-left col-sm-12 col-md-12 col-lg-12">
            <label v-if="product">
              <router-link v-if="mainGamme" :to="mainGammeLink" class="gamme-link">
                {{ mainGamme }}
              </router-link>
              <span v-if="mainGamme"> > </span>
              <router-link v-if="subGamme" :to="subGammeLink" class="gamme-link">
                {{ subGamme }}
              </router-link>
              <span v-if="subGamme"> > </span>
              <span v-if="product.name">{{ product.name }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="product-details-page container">
        <div class="row">
          <div class="content col-sm-12 col-md-12 col-lg-12">
            <ProductMediaInfo :product_detail="product" :products="products" />
          </div>
        </div>
      </div>
    </div>

    <div class="rest-gamme-block bg-light-1">
      <div class="product-reste-gamme container">
        <div class="row">
          <div class="content col-lg-12 col-md-12 col-sm-12">
            <ResteProductGamme v-if="reste_products_gamme.length" :ProductsRec="reste_products_gamme" />
          </div>
        </div>
      </div>
    </div>

    <div class="service-list bg-white">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Service />
        </div>
      </div>
    </div>

    <div class="question-list bg-light">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Question />
        </div>
      </div>
    </div>
  
  </template>
   
  </template>
</template>

<script>
  import ProductMediaInfo from "@/components/products/ProductMediaInfo.vue";
  import ResteProductGamme from "@/components/products/ResteProductGamme.vue";
  import Service from "@/components/Service.vue";
  import Question from "@/components/Question.vue";
  import { useProductStore, useProductsStore } from "@/stores/productsStore";
  import { useGammesStore } from "@/stores/gammesStore";
  import { useDelegueStore } from '@/stores/delegueStore';
  import { useRegisterStore } from '@/stores/register';

  export default {
    name: "ProductListPage",
    components: {
      ProductMediaInfo,
      ResteProductGamme,
      Service,
      Question,
    },
    data() {
      return {
        productStore: null,
        productsStore: null,
        gammesStore: null,
        size: "50px",
        color: "#3498db",
      };
    },
    computed: {
      spinnerStyle() {
        return {
          width: this.size,
          height: this.size,
          borderColor: `${this.color} transparent transparent transparent`,
        };
      },
      product() {
        return this.productStore.product;
      },
      products() {
        return this.productsStore.allProducts;
      },
      reste_products_gamme() {
        if (!this.product || !this.product.mainTaxonSupplyvet || !this.gammes.length) return [];
        const mainTaxon = this.product.mainTaxonSupplyvet;
        const relatedTaxons = [];
        for (const gamme of this.gammes) {
          if (gamme.children.some(child => mainTaxon.includes(child.split("/").pop()))) {
            gamme.children.forEach(child => {
              relatedTaxons.push(child.split("/").pop());
            });
            break;
          }
        }
        return this.productsStore.allProducts.filter(
          product =>
            relatedTaxons.some(taxon => product.mainTaxonSupplyvet && product.mainTaxonSupplyvet.includes(taxon)) &&
            product.id != this.product.id
        );
      },
      loading() {
        return this.productStore.loading_product;
      },
      gammes() {
        return this.gammesStore ? this.gammesStore.gammes : [];
      },
      mainGamme() {
        if (!this.product || !this.product.mainTaxonSupplyvet || !this.gammes.length) return "";
        const mainTaxon = this.product.mainTaxonSupplyvet;
        console.log(this.product.mainTaxonSupplyvet, "product mainTaxon");
        console.log(this.product.mainTaxonSupplyvet, "mainTaxon");
        console.log(this.gammes, "gammes gammes");
        for (const gamme of this.gammes) {
          
          if (gamme.children.some(child => mainTaxon.includes(child.split("/").pop()))) {
            console.log("gamme trouvée", gamme.name);
            return gamme.name;
          }
        }

        console.log("gamme non trouvée", this.product.mainTaxon)
        return "";
      },
     subGamme() {
        if (!this.product || !this.product.mainTaxonSupplyvet || !this.gammes.length) return "";

        const mainTaxon = this.product.mainTaxonSupplyvet;

        for (const gamme of this.gammes) {
          if (!gamme.childrenDetails || !Array.isArray(gamme.childrenDetails)) continue; // ✅ sécurisation

          const child = gamme.childrenDetails.find(child => mainTaxon.includes(child.code));
          if (child) {
            return child.name;
          }
        }

        return "";
      },


      mainGammeLink() {
      if (!this.product || !this.product.mainTaxonSupplyvet || !this.gammes.length) return "";
      const mainTaxon = this.product.mainTaxonSupplyvet;
      for (const gamme of this.gammes) {
        if (gamme.children.some(child => mainTaxon.includes(child.split("/").pop()))) {
          return `/dashboard/taxon/${gamme.id}-${gamme.slug}`;
        }
      }
      return "";
    },
    subGammeLink() {
      if (!this.product || !this.product.mainTaxonSupplyvet || !this.gammes.length) return "";
      const mainTaxon = this.product.mainTaxonSupplyvet;
      for (const gamme of this.gammes) {
        const child = gamme.childrenDetails.find(child => mainTaxon.includes(child.code));
        if (child) {
          return `/dashboard/taxon/${child.id}-${child.slug}`;
        }
      }
      return "";
    },
      isDelegue() {
        return this.registerStore.user?.role === "delegues";
      },
      selectedVeterinarian() {
        const delegueStore = useDelegueStore();
        return delegueStore.getSelectedVeterinarian;
      },
    },
    created() {
      this.registerStore = useRegisterStore();
      const ProductSlug = this.$route.params.slug;
      this.productStore = useProductStore();
      this.productStore.DetailProduct(ProductSlug);

      this.productsStore = useProductsStore();
      var WaitLoad = false;
      this.productsStore.fetchProducts(WaitLoad);

      this.gammesStore = useGammesStore();
      this.gammesStore.fetchGammes();
    },
  };
</script>

<style scoped>
 

  .product-reste-gamme,
  .service-list {
    padding: 30px;
    text-align: center;
    max-width: 100%;
  }

  .question-list {
    padding: 40px;
    text-align: center;
    max-width: 100%;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    .title-page {
      font-size: 30px;
      font-weight: bold;
      color: #1e347d;
    }
    label {
      font-size: 15px;
      font-weight: normal;
      span {
        color: #1e347d;
      }
    }
  }

  @media (max-width: 768px) {
    .product-details-page {
      padding: 15px;
    }
    .product-reste-gamme {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }


  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    .title-page {
      font-size: 30px;
      font-weight: bold;
      color: #1e347d;
    }
    label {
      font-size: 15px;
      font-weight: normal;
      span {
        color: #1e347d;
      }
    }
    .gamme-link {
      color: #1e347d;
      text-decoration: none;
      cursor: pointer;
    }
    .gamme-link:hover {
      text-decoration: underline;
    }
  }


  .delegate-warning{
    margin-top: 5rem !important;
    text-align: center;
  }
</style>
